import React, { useEffect, createElement } from 'react';
import { Toaster } from 'sonner';
import { PRODUCT_DATA } from './utils/constants';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { EmotionalTransition } from './components/EmotionalTransition';
import { ProductPresentation } from './components/ProductPresentation';
import { WhatIsIncluded } from './components/WhatIsIncluded';
import { PackComposite } from './components/PackComposite';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TrustBar } from './components/TrustBar';
import { FAQSection } from './components/FAQSection';
import { PurchasePopup } from './components/PurchasePopup';
import { Footer } from './components/Footer';
import { CountdownTimer } from './components/CountdownTimer';
export function App() {
  // Initialize Meta Pixel
  useEffect(() => {
    try {
      // @ts-ignore
      if (typeof window !== 'undefined' && window.fbq) {
        // @ts-ignore
        window.fbq('init', PRODUCT_DATA.pixelId);
        // @ts-ignore
        window.fbq('track', 'PageView');
      } else {
        // Fallback script injection if not already in index.html
        const script = document.createElement('script');
        script.innerHTML = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${PRODUCT_DATA.pixelId}');
          fbq('track', 'PageView');
        `;
        document.head.appendChild(script);
      }
    } catch (error) {
      console.error('Error initializing Meta Pixel:', error);
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-0">
      <Toaster data-id="element-1" />
      <PurchasePopup data-id="element-2" />
      <StickyBar data-id="element-3" />

      <main data-id="element-4">
        <HeroSection data-id="element-5" />
        <SocialProof data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <EmotionalTransition data-id="element-8" />
        <ProductPresentation data-id="element-9" />
        <WhatIsIncluded data-id="element-10" />
        <PackComposite data-id="element-11" />
        <BonusSection data-id="element-12" />
        <UrgencySection data-id="element-13" />
        <OfferSection data-id="element-14" />
        <TestimonialsSection data-id="element-15" />
        <GuaranteeSection data-id="element-16" />
        <TrustBar data-id="element-17" />
        <FAQSection data-id="element-18" />

        {/* Final CTA Section */}
        <section className="py-20 px-4 bg-blue-900 text-center" data-id="element-19">
          <div className="container mx-auto max-w-3xl" data-id="element-20">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-8" data-id="element-21">
              No dejes pasar esta oportunidad
            </h2>
            <div className="flex justify-center mb-10" data-id="element-22">
              <CountdownTimer variant="light" data-id="element-23" />
            </div>
            <a href={PRODUCT_DATA.paymentLink} target="_blank" rel="noopener noreferrer" className="inline-block bg-green-500 hover:bg-green-600 text-white text-2xl font-bold py-6 px-12 rounded-full shadow-[0_0_20px_rgba(34,197,94,0.4)] hover:shadow-[0_0_30px_rgba(34,197,94,0.6)] transition-all duration-300 animate-pulse-fast" data-id="element-24">
              COMPRAR AHORA
            </a>
          </div>
        </section>
      </main>

      <Footer data-id="element-25" />
    </div>;
}